<template>
  <div>
    <div class="tw-py-2 sm:tw-py-0 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-if="isEditing">
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">
        <slot name="title">{{ title }}</slot>
      </dt>
      <div class="tw-flex tw-items-center sm:tw-pt-4 sm:tw-col-span-2">
        <base-form ref="form" class="tw-w-full" v-model="isFormValid">
          <slot />
        </base-form>
      </div>
      <div class="sm:tw-flex sm:tw-flex-row-reverse sm:tw-items-center">
        <base-button size="sm" @click="save" :loading="isLoading" class="tw-w-full sm:tw-w-auto sm:tw-ml-3" :disabled="!isFormValid">Save</base-button>
        <base-button size="sm" type="flat" @click="$emit('update:isEditing', false)" class="tw-w-full sm:tw-w-auto tw-mt-2 sm:tw-mt-0">Cancel</base-button>
      </div>
    </div>
    <div class="tw-py-2 sm:tw-py-4 sm:tw-grid sm:tw-grid-cols-4 sm:tw-gap-4" v-else>
      <dt class="tw-text-xs sm:tw-text-sm tw-text-gray-500 tw-font-light tw-flex tw-items-center">
        <slot name="title">{{ title }}</slot>
      </dt>
      <dd class="tw-mt-1 tw-flex tw-items-end sm:tw-items-center tw-text-sm tw-text-gray-900 sm:tw-mt-0 sm:tw-col-span-3 tw-mb-0">
        <span class="tw-flex-grow"
          ><slot name="value">{{ value || "-" }}</slot>
        </span>
        <span class="tw-ml-4 tw-flex-shrink-0">
          <base-button type="text" @click="$emit('update:isEditing', true)" v-if="!isLocationFiltered">Update</base-button>
        </span>
      </dd>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    title: String,
    isLoading: Boolean,
    isEditing: Boolean,
    value: String,
  },
  data() {
    return {
      isFormValid: true,
    };
  },
  computed: {
    ...mapGetters("role", ["isLocationFiltered"]),
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;

      this.$emit("save");
    },
  },
};
</script>
